import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Services
import { ToolsService } from 'src/app/services/tools.service';
import { ExampleService } from 'src/app/services/example.service';
import { ConfigService } from 'src/app/services/config.service';
import { SocketService } from 'src/app/services/socket.service';
import { AuthService } from 'src/app/services/auth.service';
import { MissionsService } from 'src/app/services/missions.service';
import { ProductsService } from 'src/app/services/products.service';
import { Storage } from '@ionic/storage';
import { AlertController, ModalController } from '@ionic/angular';
// import { Events } from '@ionic/angular';
import { ModalRedeemCouponPage } from 'src/app/modals/modal-redeem-coupon/modal-redeem-coupon.page';
import { NitsRepresentativeService } from 'src/app/services/nits-representative.service';
import { AcceptTermsAndConditionsPage } from 'src/app/modals/accept-terms-and-conditions/accept-terms-and-conditions.page';
import { AutomaticPointsSettingsPage } from 'src/app/modals/automatic-points-settings/automatic-points-settings.page';
import { ModalIaModulePage } from 'src/app/modals/modal-ia-module/modal-ia-module.page';
export class HeaderComponent {
    constructor(exampleService, router, toolsService, configService, socketService, authService, nitsRepresentative, missionsService, productService, storage, alertController, 
    // private events: Events,
    modalController) {
        this.exampleService = exampleService;
        this.router = router;
        this.toolsService = toolsService;
        this.configService = configService;
        this.socketService = socketService;
        this.authService = authService;
        this.nitsRepresentative = nitsRepresentative;
        this.missionsService = missionsService;
        this.productService = productService;
        this.storage = storage;
        this.alertController = alertController;
        this.modalController = modalController;
        this.isLogin = false;
        this.profileMenuOptions = ["Mi perfil", "Mis Redenciones", "Mis favoritos", "Mis misiones", "Transacciones", "Notificaciones"]; //Default options
        this.products = [];
        this.loadingProducts = false;
        this.inAuthPage = false;
        this.canShowPromotion = null;
        this.showNews = false;
        this.showSocialFeed = false;
        this.showWallet = false;
        this.isRTC = false;
        this.isCOOR = false; // Indica si el usuario tiene dependientes 
        this.metasButton = false;
        this.kpiOnMenu = [];
        this.companis_button_metas = ['liga_centelsa', 'gabriamigos', 'incolma', 'ramo', 'comunidad tigo', 'polar', 'demo 2'];
        this.iaTemplates = [];
        console.log(this.configService.company_info);
        this.loadInitialData();
        this.configService.getEvents().subscribe((event) => {
            if (event.name != 'loadInitialData')
                return;
            console.debug("loadInitialData");
            this.loadInitialData();
        });
        if (this.router.url.includes('/autenticacion'))
            this.inAuthPage = true;
    }
    ngOnInit() {
        this.activateDeactivateMenus();
        this.filterVariants();
        this.loadFullPlayerData();
        this.loadIaActivities();
        this.getPlayerRankingInfo();
    }
    activateDeactivateMenus() {
        let modulesEnabled = this.configService.company_info.modules_enabled;
        if (modulesEnabled) {
            if (modulesEnabled.includes('NEWS')) {
                this.showNews = true;
            }
            if (modulesEnabled.includes('SOCIAL')) {
                this.showSocialFeed = true;
            }
        }
        if (this.configService.company_info.wallet_active)
            this.showWallet = true;
    }
    openWallet() {
        this.router.navigate(['/billetera']);
    }
    loadInitialData() {
        if (this.authService.isLogged) {
            this.loadProfileMenuOptions();
            this.loadInitialPlayerData();
            // this.loadFullPlayerData();
        }
        this.validatePromotionExistence();
        this.loadCategories();
        this.metasButton = false;
        for (const i of this.companis_button_metas) {
            console.log("Checking company for metas button:", i, this.configService.company_info.name.toLowerCase(), this.configService.company_info.name.toLowerCase().includes(i));
            if (this.configService.company_info.name.toLowerCase().includes(i)) {
                this.metasButton = true;
            }
        }
    }
    //Function to load Menu options
    loadProfileMenuOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.missionsOnMenu = yield this.missionsService.getMissiononMenuQuestions();
                this.missionsResponseOnMenu = yield this.missionsService.getMissiononResponseMenuQuestions();
                console.log(this.missionsOnMenu);
                console.log(this.missionsResponseOnMenu);
            }
            catch (error) {
                if (error.status != 401) {
                    this.toolsService.showErrorToast();
                    console.error('[HEADER-COMPONENT] loadProfileMenuOptions()', error);
                }
            }
        });
    }
    //Function to go to home and reset breadcrumbs
    goToRoot() {
        this.router.navigate(['inicio']);
        this.toolsService.resetBreadCrumbs();
    }
    //Function to change page
    goToPage(path, option = null) {
        // If path is string and starts with http, open in new tab
        if (typeof path === 'string' && path.startsWith('http')) {
            window.open(path, '_blank');
            return;
        }
        if (path.includes('#')) {
            option = path.split('#')[1];
            path = path.split('#')[0];
        }
        console.debug('[HEADER-COMPONENT] goToPage()', path, option);
        if (option) {
            this.router.navigate([path]);
            var available_options = this.profileMenuOptions;
            if (option == "Mis misiones") {
                return this.openMyMissions();
            }
            if (this.configService.queryParams.hideProfile) {
                var index = available_options.indexOf('Mi perfil');
                if (index != -1)
                    available_options.splice(index, 1);
            }
            if (this.configService.queryParams.hideMissions) {
                var index = available_options.indexOf('Mis misiones');
                if (index != -1)
                    available_options.splice(index, 1);
            }
            if (this.configService.queryParams.hideFavorites) {
                var index = available_options.indexOf('Mis favoritos');
                if (index != -1)
                    available_options.splice(index, 1);
            }
            if (this.configService.queryParams.hideTransactions) {
                var index = available_options.indexOf('Transacciones');
                if (index != -1)
                    available_options.splice(index, 1);
            }
            if (this.configService.queryParams.hideNotifications) {
                var index = available_options.indexOf('Notificaciones');
                if (index != -1)
                    available_options.splice(index, 1);
            }
            if (this.configService.queryParams.hideLevels) {
                var index = available_options.indexOf('Niveles');
                if (index != -1) {
                    available_options.splice(index, 1);
                }
            }
            if (this.configService.queryParams.hideTarget) {
                var index = available_options.indexOf('Mis productos en la mira');
                if (index != -1) {
                    available_options.splice(index, 1);
                }
            }
            if (this.configService.queryParams.hideReferrals) {
                var index = available_options.indexOf('Mis referidos');
                if (index != -1)
                    available_options.splice(index, 1);
            }
            console.debug('[HEADER-COMPONENT] goToPage() - available_options', available_options);
            this.exampleService.index = available_options.indexOf(option.toString());
        }
        else {
            this.router.navigate([path]).catch(e => {
                window.open(path, '_blank');
            });
        }
    }
    isPageActive(page) {
        if (!this.configService || !this.configService.queryParams)
            return true;
        if (page == 'Mi perfil' && this.configService.queryParams.hideProfile)
            return false;
        else if (page == 'Mis misiones' && this.configService.queryParams.hideMissions)
            return false;
        else if (page == 'Mis favoritos' && this.configService.queryParams.hideFavorites)
            return false;
        else if (page == 'Transacciones' && this.configService.queryParams.hideTransactions)
            return false;
        else if (page == 'Notificaciones' && this.configService.queryParams.hideNotifications)
            return false;
        else
            return true;
    }
    //Function to logout the user
    logout() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.toolsService.showLoader();
            try {
                yield this.authService.logout();
                this.router.navigate(['autenticacion']);
            }
            catch (error) {
                this.toolsService.showErrorToast();
                console.error('[HEADER-COMPONENT] logout()', error);
            }
            yield this.toolsService.dismissLoader();
        });
    }
    //Function to open mission by id
    openMission(mission_id) {
        this.router.navigate(['misiones/' + mission_id]);
    }
    //Function to open mission responses by id
    openMissionResponses(mission) {
        this.router.navigate(['respuestas/' + mission.id]);
        this.storage.set('response_item_menu', mission.response_item_menu);
    }
    // ---- Busca el grupo RCT_GBR para la compañia  
    loadFullPlayerData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const playerFullData = yield this.authService.getPlayerFullData();
            console.debug('playerFullData', playerFullData);
            if (!playerFullData)
                return;
            // Check if player has kpis to show
            yield this.getKpisToShow();
            const gruposPlayer = playerFullData.groups;
            const companyId = playerFullData.company;
            const groups = yield this.nitsRepresentative.getGroupsPlayer(companyId, false);
            // ---- Busca el grupo RTC_GBR para la compañia
            const isRepresentative = gruposPlayer.some((id) => {
                return groups.some((group) => group.id === id && group.name.includes('RTC_GBR'));
            });
            // ---- Busca el grupo COOR- en el id del player 
            const haveDependents = gruposPlayer.some((id) => {
                return groups.some((group) => group.id === id && group.name.includes('COOR-'));
            });
            console.log('haveDependents', haveDependents);
            this.filtrarCallToActions(isRepresentative);
            this.filtrarCallToActionsDependents(haveDependents);
        });
    }
    getKpisToShow() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let kpisToShow;
            try {
                kpisToShow = yield this.authService.getPlayerKpis();
            }
            catch (error) {
                console.debug('Error getting kpis', error);
                return;
            }
            console.debug('kpisToShow', kpisToShow);
            if (!kpisToShow || kpisToShow.length == 0)
                return;
            for (const kpi of kpisToShow) {
                this.kpiOnMenu.push(kpi);
            }
            console.debug('kpiOnMenu', this.kpiOnMenu);
        });
    }
    openKpi(kpi) {
        this.router.navigate(['kpi/' + kpi.slug]);
    }
    // ------ Pinta el botón 'Nits asociados' SI isRepresentative == true -------- 
    filtrarCallToActions(isRepresentative = false) {
        this.isRTC = isRepresentative;
        if (this.configService.company_info && this.configService.company_info.call_to_actions) {
            this.filteredCallToActions = isRepresentative
                ? this.configService.company_info.call_to_actions
                : this.configService.company_info.call_to_actions.filter(button => button.path !== "/trade-representative/");
        }
    }
    // ------ Pinta el botón 'Mis dependientes' SI haveDependents == true -------- 
    filtrarCallToActionsDependents(haveDependents = false) {
        this.isCOOR = haveDependents;
        if (this.configService.company_info && this.configService.company_info.call_to_actions) {
            this.filteredCallToActions = haveDependents
                ? this.configService.company_info.call_to_actions
                : this.configService.company_info.call_to_actions.filter(button => button.path !== 'dependents');
        }
    }
    filterVariants() {
        if (this.configService.company_info.variants) {
            this.filteredVariants = this.configService.company_info.variants.filter(variant => !variant.current);
        }
    }
    //Function to load name and points of the user
    loadInitialPlayerData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.playerData = yield this.authService.getPlayerInitialData();
                if (!this.playerData.is_active) {
                    yield this.logout();
                    window.location.reload();
                }
                if (!this.playerData)
                    return;
                if (!this.playerData.terms_conditions_accepted && this.toolsService.termAndConditions) {
                    this.toolsService.termAndConditions = false;
                    yield this.acceptTermsAndConditions();
                }
                var alerts_info = yield this.socketService.getNumberAlerts();
                this.socketService.number_alerts = alerts_info['number'];
                var response = yield this.socketService.getPlayerAlerts();
                if (response)
                    this.socketService.alerts = response['results'];
                this.playerData.user.first_name = this.playerData.user.first_name.split(' ')[0];
                this.playerData.user.last_name = this.playerData.user.last_name.split(' ')[0];
                if (this.playerData.level)
                    this.profileMenuOptions.push('Niveles');
                if (!this.configService.queryParams.hideTarget)
                    this.profileMenuOptions.push('Mis productos en la mira');
                if (this.configService.company_info.referral_module)
                    this.profileMenuOptions.push('Referidos');
                if (this.configService.company_info.modules_enabled.includes('REFERRALS'))
                    this.profileMenuOptions.push(this.configService.company_info.custom_referral_registered_name ? this.configService.company_info.custom_referral_registered_name : "Mis Referidos");
                if (!window.location.href.includes('complete-order')) {
                    console.log("loading shopping cart", window.location.href);
                    yield this.productService.loadShoppingCart();
                }
                console.log('');
                this.configService.groupsPlayer = this.playerData.groups;
            }
            catch (error) {
                console.error("[HEADER-COMPONENT] loadInitialPlayerData()", error);
                if (error.status != 401) {
                    this.toolsService.showErrorToast();
                }
            }
        });
    }
    // Function to accept terms and conditions modal
    acceptTermsAndConditions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modalOptions = {
                component: AcceptTermsAndConditionsPage,
                backdropDismiss: false,
                cssClass: 'tyc-modal-class',
            };
            const modal = yield this.modalController.create(modalOptions);
            modal.componentProps = {
                terms: this.configService.company_info.terms,
            };
            yield modal.present();
            const { data } = yield modal.onDidDismiss();
            if (data.accepted) {
                const body = {
                    "terms_conditions_accepted": true,
                    "player_id": this.playerData.id
                };
                yield this.authService.sendAcceptTermsAndConditions(body);
                this.playerData.terms_conditions_accepted = true;
            }
            else {
                yield this.logout();
                window.location.reload();
            }
        });
    }
    searchProducts() {
        var productsRegex = /\/productos/;
        var finalURL = 'productos';
        var currentURL = this.router.url;
        if (productsRegex.test(currentURL))
            finalURL = currentURL.replace(/\?.*/, '');
        this.router.navigate([finalURL], { queryParams: { name: this.productName } });
    }
    loadCategories() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.categories = yield this.productService.getSubCategories(null);
        });
    }
    //Function to open category
    openCategory(category) {
        var fixedPath = 'productos/' + category.odoo_id + "-" + category.name.toLowerCase().replace(/\s/g, '_');
        this.router.navigate([fixedPath]);
    }
    openPromotions(productos) {
        var fixedPath = 'productos-en-promocion/' + productos;
        this.router.navigate([fixedPath]);
    }
    onChangeSearchbar(name) {
        setTimeout(() => {
            if (this.productName != name)
                return;
            else {
                this.searchProductsLite(this.productName);
            }
        }, 500);
    }
    searchProductsLite(name) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loadingProducts = true;
            try {
                var result = yield this.productService.getProductsLite(name);
                ;
                this.products = result.results;
            }
            catch (error) {
                console.error('[HEADER-COMPONENT] searchProductsLite()', error);
            }
            this.loadingProducts = false;
        });
    }
    openProductDetail(product) {
        this.storage.set('previous_search', product);
        this.router.navigate(['/producto/' + product.id]);
    }
    displayFn(option) {
        return option && option.name ? option.name : '';
    }
    // Function to Scroll to Section
    scrollTo(elementId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.isLogin)
                yield this.router.navigate(['autenticacion']);
            document.getElementById(elementId).scrollIntoView({ behavior: 'smooth' });
        });
    }
    //Function to open coupon pop up
    openCouponPopup() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                header: 'Redime tu Cupón',
                inputs: [
                    {
                        name: 'code',
                        type: 'text',
                        placeholder: 'Código'
                    }
                ],
                buttons: [
                    {
                        text: 'Cancelar',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Confirm Cancel');
                        }
                    }, {
                        text: 'Ok',
                        handler: (data) => {
                            if (data.code) {
                                if (!this.authService.isLogged) {
                                    this.authService.couponCode = data.code;
                                    this.toolsService.showErrorToast("Debes iniciar sesión para redimir tu cupón");
                                    this.scrollTo('login');
                                }
                                else {
                                    this.validateCoupon(data.code);
                                }
                            }
                            else {
                                this.toolsService.showErrorToast("Debes colocar un código");
                                return false;
                            }
                        }
                    }
                ]
            });
            yield alert.present();
        });
    }
    validateCoupon(code) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.toolsService.showLoader();
            try {
                var coupon = yield this.productService.validateCoupon(code);
                if (coupon.coupon_type == 'CREDIT') {
                    if (this.isLogin)
                        yield this.router.navigate(['inicio/']);
                    this.presentCreditCouponAlert(coupon);
                }
                else if (coupon.products) {
                    this.productService.coupon_used = coupon;
                    if (coupon.products.length == 1) {
                        if (coupon.custom_product_value)
                            coupon.products[0] = this.configService.fixCustomProduct(coupon.products[0], coupon.custom_product_value);
                        this.router.navigate(['carrito-de-compras/']);
                        this.checkCategory(coupon.products[0]);
                    }
                    else
                        this.router.navigate(['productos/']);
                }
            }
            catch (error) {
                if (error.status == 406)
                    this.toolsService.showErrorToast(error.error.error);
                else
                    this.toolsService.showErrorToast();
                console.error('[HEADER-COMPONENT] validateCoupon()', error);
            }
            yield this.toolsService.dismissLoader();
        });
    }
    presentCreditCouponAlert(coupon) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                header: coupon.campaign_name,
                message: 'Este cupón te regala ' + coupon.credit_amount + this.configService.company_info.points_name + ' , para que los uses en tus próximas redenciones',
                buttons: [
                    {
                        text: 'Cancelar',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.log('Confirm Cancel');
                        }
                    }, {
                        text: 'Aceptar',
                        handler: () => {
                            this.redeemCreditCoupon(coupon);
                        }
                    }
                ]
            });
            yield alert.present();
        });
    }
    redeemCreditCoupon(coupon) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.toolsService.showLoader();
            try {
                yield this.productService.redeemCoupon(coupon.id);
                this.playerData.points += coupon.credit_amount;
                this.toolsService.showSuccessToast("Cupón redimido correctamente");
            }
            catch (error) {
                this.toolsService.showErrorToast();
                console.error('[HEADER-COMPONENT] redeemCreditCoupon()', error);
            }
            yield this.toolsService.dismissLoader();
        });
    }
    openAlert(player_alert) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (player_alert.alert.alert_type == 'NEW_COUPON')
                    this.openCouponPopup();
                else if (player_alert.alert.alert_type == 'NEW_MISSION')
                    this.router.navigate(['misiones/' + player_alert.alert.mission]);
                else if (player_alert.alert.alert_type == 'NEW_PROMOTION')
                    this.router.navigate(['productos']);
                else if (player_alert.alert.alert_type == 'RESPONSE_UPDATED')
                    this.router.navigate(['misiones']);
                else if (player_alert.alert.alert_type == 'SALE_ORDER_UPDATED')
                    this.router.navigate(['perfil']);
                else if (player_alert.alert.alert_type == 'NEW_POST')
                    this.router.navigate(['muro']);
                else if (player_alert.alert.alert_type == 'NEW_NEWS')
                    this.router.navigate(['noticias']);
                yield this.socketService.markAsSeen(player_alert.id);
                this.socketService.number_alerts -= 1;
                player_alert.was_seen = true;
            }
            catch (error) {
                this.toolsService.showErrorToast();
                console.error('[HEADER-COMPONENT] openAlert()', error);
            }
        });
    }
    // Function to check if category is digital coupons
    checkCategory(product) {
        product = this.productService.normaliseProduct(product, false, 0, product.price - product.discount, 100, 100, 100);
        if (this.authService.isLogged) {
            if (!this.productService.validateNumberOfProducts(product, 1)) {
                this.toolsService.showErrorToast("No puedes agregar más de 10 productos al carrito");
                return;
            }
            if (product.brand_id || product.mega_coupon) // it is coupon
                this.presentReedemCouponModal(product);
            else
                this.addProductShoopingCart(product);
        }
        else
            this.toolsService.showErrorToast("Debes ingresar para agregar un producto al carrito");
    }
    presentReedemCouponModal(product) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalController.create({
                component: ModalRedeemCouponPage,
                componentProps: {
                    product: product
                }
            });
            modal.onDidDismiss()
                .then((response) => {
                if (response.data) {
                    product.additional_info = response.data;
                    this.addProductShoopingCart(product);
                }
            });
            return yield modal.present();
        });
    }
    addProductShoopingCart(product) {
        if (product.coupon_used) {
            // Validation coupon is not already used
            var coupon_exists = this.productService.shooping_cart.find(item => item.coupon_used && item.coupon_used == product.coupon_used);
            if (coupon_exists) {
                this.toolsService.showErrorToast("Ya estás usando este cupón en tu carrito");
                return;
            }
        }
        if (product.promotion)
            product.number_of_products = product.promotion.number_of_products;
        this.toolsService.showSuccessToast('Producto agregado al carrito');
        product['quantity'] = 1;
        this.productService.addProduct(product);
    }
    validatePromotionExistence() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.canShowPromotion == null) {
                let response = yield this.productService.validatePromotionExistence();
                if (response)
                    this.canShowPromotion = response.show_promotion_category;
            }
        });
    }
    openNews() {
        console.log('NOTICIAS');
        this.router.navigate(['noticias']).catch(e => {
            window.open('noticias');
        });
    }
    openMyMissions() {
        console.log('MISIONES');
        this.router.navigate(['misiones']).catch(e => {
            window.open('misiones');
        });
    }
    openFeed() {
        this.router.navigate(['muro']).catch(e => {
            window.open('muro');
        });
    }
    navigateToMetas() {
        this.router.navigate(['/inicio']).then(() => {
            setTimeout(() => {
                this.router.navigate(['/inicio'], { fragment: 'tusmetas' });
            }, 100);
        });
    }
    navigateToRanking() {
        this.router.navigate(['/ranking']).then(res => {
        });
    }
    getPlayerRankingInfo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.missionsService.getRankingByActivity();
            this.rankingResponse = response;
        });
    }
    get showCallToActionContainer() {
        if (!this.configService.company_info)
            return false;
        if (this.configService.company_info.call_to_actions && this.configService.company_info.call_to_actions.length > 0)
            return true;
        if (this.configService.company_info.modules_enabled && this.configService.company_info.modules_enabled.indexOf('COUPONS') != -1)
            return true;
        if (this.configService.company_info.variants && this.configService.company_info.variants.length > 1)
            return true;
        if (this.configService.company_info.wallet_active && this.configService.company_info.wallet_product_id)
            return true;
        return false;
    }
    goToVariant(variantDomain) {
        this.configService.goToVariant(variantDomain);
    }
    getIdName(name) {
        return "options-" + name.toLowerCase().replace(/\s/g, '-');
    }
    goToWalletProduct() {
        this.router.navigate(['/producto/' + this.configService.company_info.wallet_product_id]);
    }
    get activateAutomaticPointsText() {
        return this.playerData && this.playerData.automatic_redemption_wallet ? 'Desactivar redención automática' : 'Activar redención automática';
    }
    showActivateButton() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalController.create({
                component: AutomaticPointsSettingsPage,
                backdropDismiss: true,
                cssClass: 'autopoints-modal-class',
            });
            modal.onDidDismiss().then((response) => { });
            return yield modal.present();
        });
    }
    loadIaActivities() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let response = yield this.missionsService.getIaActivity(true);
                this.iaTemplates = response;
                console.debug('[HEADER-COMPONENT] loadIaActivities', this.iaTemplates);
            }
            catch (error) {
                console.error('Error loading header activities', error);
            }
        });
    }
    getTemplateName(template) {
        if (template.settings.length == 0)
            return template.name;
        let templateSettings = template.settings[0];
        if (templateSettings.name)
            return templateSettings.name;
        return template.name;
    }
    openIaModal(template) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // Encuentra la actividad con el ID dado
            const modal = yield this.modalController.create({
                component: ModalIaModulePage,
                cssClass: 'iaModal',
                componentProps: {
                    template: template,
                    seeFiles: false,
                    playerData: this.playerData
                }
            });
            return yield modal.present();
        });
    }
    redirectToUrl() {
        this.configService.redirectUrl().subscribe(response => {
            if (response.url) {
                window.open(response.url, '_blank');
            }
            else {
                console.error('No se recibió URL');
            }
        }, error => {
            console.error('Error al obtener la URL', error);
        });
    }
    getCustomCss() {
        return this.configService.getCustomCss();
    }
}
